import React from 'react';
import Hero from '../components/hero-section/Hero';
import Navbar from '../components/navbar/Navbar';
import HomeImg from '../assets/home.jpg';
import Destination from '../components/popular-destinations/Destination';
import RecentTrips from '../components/recent-trips/Trips';
import Footer from '../components/footer-section/Footer';

const Home = () => {
    return (
        <div>
            <Navbar />
            <Hero
                cName="hero"
                heroImg={HomeImg}
                title="Your Metal Forming Journey Starts Here"
                text="Choose your favouraite topic and start learning."
                url="/"
                btnClass="show"
                buttonText="METAL.AI"
            />
            <Destination />
            <RecentTrips />
            <Footer />



        </div>
    );
}

export default Home;